module.exports = __webpack_public_path__ + "img/prepay-cards.d4325dd.svg";